module.exports = __webpack_public_path__ + "static/media/stockhausen_folkwang_10.28490ddc.jpg";